import { AreaSelectorComboBox } from "@/services/backend/qpm/buildings/components/area-selector";
import {
  Area,
  AreaList,
} from "@/services/backend/qpm/buildings/types/building";
import { AreaType } from "@/services/backend/qpm/buildings/types/building-enum";
import { newRequirementAreaRisks } from "@/services/backend/qpm/requirements/types/requirement";
import type { RequirementArea } from "@/services/backend/qpm/requirements/types/requirement-area";
import { useCallback } from "react";
import { useRequirementEdit } from "@/services/backend/qpm/requirements/hooks/requirement-context";
import t from "@/lang/lang";

export type RequirementAreaSelectorProps = {
  areas?: AreaList;
  buildingId?: string;
  levelId?: string;
  areaType: AreaType;
};

export function RequirementAreaSelector({
  areas,
  buildingId,
  levelId,
  areaType,
}: RequirementAreaSelectorProps) {
  const { updateRequirement } = useRequirementEdit();

  const handleAreaSelect = useCallback(
    (area: Area) => {
      if (!area) return;

      updateRequirement((prevReq) => {
        // prevent duplicates
        if (prevReq.areaList?.some((a) => a.areaId === area.base.id)) {
          return {};
        }

        const newArea: RequirementArea = {
          area,
          areaId: area.base.id,
          amountOfMeasures: 0,
          risks: newRequirementAreaRisks(area.base.id),
          createdAt: new Date().toISOString(),
        };

        return {
          areaList: [...(prevReq.areaList ?? []), newArea],
        };
      });
    },
    [updateRequirement],
  );

  return (
    <AreaSelectorComboBox
      areas={areas}
      onAreaSelect={handleAreaSelect}
      buildingId={buildingId}
      levelId={levelId}
      areaType={areaType}
      triggerLabel={
        areaType === AreaType.AreaTypeInside
          ? t("Innenbereich wählen oder anlegen")
          : t("Außenbereich wählen oder anlegen")
      }
      onAreaCreate={handleAreaSelect}
    />
  );
}
